var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 9.5V11H1V9.5C1 9.225 1.225 9 1.5 9H10.5C10.775 9 11 9.225 11 9.5Z",
    fill: "#7D14FF",
    stroke: "#7D14FF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 5.5H2.5V9H3.5V5.5Z",
    fill: "#7D14FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 5.5H4.5V9H5.5V5.5Z",
    fill: "#7D14FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5.5H6.5V9H7.5V5.5Z",
    fill: "#7D14FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5.5H8.5V9H9.5V5.5Z",
    fill: "#7D14FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 11.375H0.5C0.295 11.375 0.125 11.205 0.125 11C0.125 10.795 0.295 10.625 0.5 10.625H11.5C11.705 10.625 11.875 10.795 11.875 11C11.875 11.205 11.705 11.375 11.5 11.375Z",
    fill: "#7D14FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.685 2.87498L6.185 1.07498C6.085 1.03498 5.915 1.03498 5.815 1.07498L1.315 2.87498C1.14 2.94498 1 3.14998 1 3.33998V4.99998C1 5.27498 1.225 5.49998 1.5 5.49998H10.5C10.775 5.49998 11 5.27498 11 4.99998V3.33998C11 3.14998 10.86 2.94498 10.685 2.87498ZM6 4.24998C5.585 4.24998 5.25 3.91498 5.25 3.49998C5.25 3.08498 5.585 2.74998 6 2.74998C6.415 2.74998 6.75 3.08498 6.75 3.49998C6.75 3.91498 6.415 4.24998 6 4.24998Z",
    fill: "#7D14FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankicon);
export default __webpack_public_path__ + "static/media/bankicon.73c0396662d2ecfa236f8fdbc6746f4f.svg";
export { ForwardRef as ReactComponent };